import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateInsuranceWebView = () => {
  deeplinkNavigation({ name: 'InsuranceWebView' })
}
